module.exports = __webpack_public_path__ + "e270f16ee9473a3784f5b0e053101419.png";